import { Label } from "components/Atoms/Label";
import { useValidateIsNotEmptyArray } from "formvalidation/hooks";
import React from "react";

interface Props<T extends unknown> {
  value: T[];
  renderLabelContent: (value: T) => React.ReactNode
  getId: (value: T) => string | number;
}

export const LabelList = <T extends unknown>(props: Props<T>) => {
  if (props.value.length === 0) {
    return <></>;
  }

  return <div className="removableLabel-list">
    {props.value.map(i => <Label
      key={props.getId(i)}
    >
      {props.renderLabelContent(i)}
    </Label>)}
  </div>;
}

interface ValidatedLabelListProps<T extends unknown> extends Props<T> {
  validatorKey: string;
}

export const ValidatedLabelList = <T extends unknown>(props: ValidatedLabelListProps<T>) => {
  const validator = useValidateIsNotEmptyArray({
    key: props.validatorKey,
    title: props.validatorKey,
    value: props.value,
  });

  if (props.value.length === 0) {
    return <div style={{
      color: validator.error.hasError ? "var(--error-color)" : undefined,
      textDecoration: "underline",
    }}>
      {RESX.Buttons.btnSelect}
    </div>
  }

  return <LabelList<T>
    value={props.value}
    renderLabelContent={props.renderLabelContent}
    getId={props.getId}
  />;
}